var _excluded = ["key"];
var _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/ManageFavoriteAndFollows/index.js";
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import ManageSection from "../ManageSection";
import { ManageFavoriteAndFollowsContainer } from "./styles";
var ComponentKey = "manage-favorite-and-follows";
var ManageFavoriteAndFollows = function ManageFavoriteAndFollows(_ref) {
  var buttonProps = _ref.buttonProps,
    className = _ref.className,
    containerProps = _ref.containerProps,
    contentRef = _ref.contentRef,
    favoriteTeam = _ref.favoriteTeam,
    _ref$favoriteTeamButt = _ref.favoriteTeamButtonLabel,
    favoriteTeamButtonLabel = _ref$favoriteTeamButt === void 0 ? "Select Favorite Team" : _ref$favoriteTeamButt,
    _ref$favoriteTeamHead = _ref.favoriteTeamHeader,
    favoriteTeamHeader = _ref$favoriteTeamHead === void 0 ? "Favorite Team" : _ref$favoriteTeamHead,
    followedPlayers = _ref.followedPlayers,
    _ref$followedPlayersB = _ref.followedPlayersButtonLabel,
    followedPlayersButtonLabel = _ref$followedPlayersB === void 0 ? "Select Followed Players" : _ref$followedPlayersB,
    _ref$followedPlayersH = _ref.followedPlayersHeader,
    followedPlayersHeader = _ref$followedPlayersH === void 0 ? "Followed Players" : _ref$followedPlayersH,
    followedTeams = _ref.followedTeams,
    _ref$followedTeamsBut = _ref.followedTeamsButtonLabel,
    followedTeamsButtonLabel = _ref$followedTeamsBut === void 0 ? "Select Followed Teams" : _ref$followedTeamsBut,
    _ref$followedTeamsHea = _ref.followedTeamsHeader,
    followedTeamsHeader = _ref$followedTeamsHea === void 0 ? "Followed Teams" : _ref$followedTeamsHea,
    headerProps = _ref.headerProps,
    onFavoriteDeleteClick = _ref.onFavoriteDeleteClick,
    onFavoriteRemove = _ref.onFavoriteRemove,
    onFollowDeleteClick = _ref.onFollowDeleteClick,
    onFollowRemove = _ref.onFollowRemove,
    onReorder = _ref.onReorder,
    onSelectFavoriteClick = _ref.onSelectFavoriteClick,
    onSelectFollowClick = _ref.onSelectFollowClick,
    rowProps = _ref.rowProps;
  // If favoriteTeam is present, filter from followedTeams
  var normalizedFollowedTeams = favoriteTeam ? followedTeams === null || followedTeams === void 0 ? void 0 : followedTeams.filter(function (team) {
    var _team$id, _favoriteTeam$id;
    return (team === null || team === void 0 ? void 0 : (_team$id = team.id) === null || _team$id === void 0 ? void 0 : _team$id.toString()) !== ((_favoriteTeam$id = favoriteTeam.id) === null || _favoriteTeam$id === void 0 ? void 0 : _favoriteTeam$id.toString());
  }) : followedTeams;
  var sections = [{
    headerLabel: favoriteTeamHeader,
    headerProps: headerProps,
    isFavorite: true,
    items: favoriteTeam ? [favoriteTeam] : [],
    key: "favoriteTeam",
    noDataButtonLabel: favoriteTeamButtonLabel,
    noDataButtonProps: buttonProps,
    onDelete: onFavoriteDeleteClick,
    onNoDataButtonClick: function onNoDataButtonClick(e) {
      return onSelectFavoriteClick(e, "Favorite Team");
    },
    onRemove: onFavoriteRemove,
    rowProps: rowProps,
    type: "team"
  }, {
    headerLabel: followedPlayersHeader,
    headerProps: headerProps,
    items: followedPlayers,
    key: "followedPlayers",
    noDataButtonLabel: followedPlayersButtonLabel,
    noDataButtonProps: buttonProps,
    onDelete: onFollowDeleteClick,
    onNoDataButtonClick: function onNoDataButtonClick(e) {
      return onSelectFollowClick(e, "Followed Players");
    },
    onRemove: onFollowRemove,
    onReorder: onReorder,
    rowProps: rowProps,
    type: "player"
  }, {
    headerLabel: followedTeamsHeader,
    headerProps: headerProps,
    key: "followedTeams",
    items: normalizedFollowedTeams,
    noDataButtonLabel: followedTeamsButtonLabel,
    noDataButtonProps: buttonProps,
    onDelete: onFollowDeleteClick,
    onNoDataButtonClick: function onNoDataButtonClick(e) {
      return onSelectFollowClick(e, "Followed Teams");
    },
    onRemove: onFollowRemove,
    onReorder: onReorder,
    rowProps: rowProps,
    type: "team"
  }];
  return /*#__PURE__*/React.createElement(ManageFavoriteAndFollowsContainer, _extends({
    className: className,
    "data-testid": ComponentKey,
    layout: true
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 84,
      columnNumber: 5
    }
  }), sections.map(function (_ref2) {
    var key = _ref2.key,
      props = _objectWithoutProperties(_ref2, _excluded);
    return /*#__PURE__*/React.createElement(ManageSection, _extends({}, props, {
      key: key,
      scrollableElementRef: contentRef,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 91,
        columnNumber: 9
      }
    }));
  }));
};
export default /*#__PURE__*/React.memo(ManageFavoriteAndFollows);